import { performSearchFilterAsync } from '@Containers/ResultsFilters/performSearchFilterAsync';
import { preparePropertiesForRequest } from '@Containers/ResultsFilters/performSearchFilterAsync/preparePropertiesUtils';
import NewRelicService, { BROWSER_INTERACTIONS_NAMES } from '@Services/NewRelicService';

import {
  filters as filtersDataSelector,
  paramsForFiltersRequest as paramsForFiltersRequestSelector,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';

import { withGlobalSpinnerActionEnhancer } from '@Utils/Redux/withGlobalSpinnerActionEnhancer';
import AppStorage from '@Services/AppStorage';

export const limitTo = withGlobalSpinnerActionEnhancer(function limitTo() {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const params = paramsForFiltersRequestSelector(state);
      let browserInteraction;
      if (params.context === 'substances') {
        browserInteraction = NewRelicService.createBrowserInteraction(BROWSER_INTERACTIONS_NAMES.TIME_TO_APPLY_FILTERS_TO_SUBSTANCES);
      }
      const filters = filtersDataSelector(state);
      const properties = preparePropertiesForRequest(filters, state);

      await performSearchFilterAsync({ filters, properties, browserInteraction });

      AppStorage.instance.setToSessionStorage('integratedFeedbackHide', true);
    } catch (e) {
      Logger.error('filters on react: limit to exception', e);
    }
  };
});

export const exclude = withGlobalSpinnerActionEnhancer(function exclude() {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const filters = filtersDataSelector(state);
      const properties = preparePropertiesForRequest(filters, state);

      await performSearchFilterAsync({
        filters,
        properties,
        baseParamsExtension: { exclude: true },
      });

      AppStorage.instance.setToSessionStorage('integratedFeedbackHide', true);
    } catch (e) {
      Logger.error('filters on react: exclude exception', e);
    }
  };
});
